/**
 * Copyright (c) Aleksei Volkov and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
export const deepCopyObject = (obj = {}) => JSON.parse(JSON.stringify(obj))

export const parseJson = (str, defaultValue = null) => {
  try {
    return JSON.parse(str)
  } catch (e) {
    return defaultValue
  }
}

export function generateUuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export const toDate = dateStr => {
  if (dateStr) {
    const [day, month, year] = dateStr?.split('.')
    return new Date(year, month - 1, day) || null
  }
  return null
}

export const hasRole = (roles = [], user = {}, key = 'roles') => {
  if (!user || !user?.[key]) {
    return false
  }
  if (Array.isArray(roles) && roles?.length === 0) {
    return true
  }
  return (
    Array.isArray(roles) &&
    !!roles?.find(
      ({ code: roleCode, project: projectCode }) =>
        !!user?.[key]?.find(
          ({ code, project }) =>
            code === roleCode && project.code === projectCode
        )
    )
  )
}

export const hasRoleByCode = (role = '', user = {}, key = 'roles') => {
  if (!user || !user?.[key] || !role) {
    return false
  }

  return !!user?.[key]?.some(({ code }) => code === role)
}

export const hasRoleById = (
  projectCode = '',
  role = '',
  user = {},
  key = 'roles'
) => {
  if (!user || !user?.[key] || !projectCode || !role) {
    return false
  }
  return user[key].some(
    item => item.code === role && item.project?.code === projectCode
  )
}
